import { parseDynamicContent } from 'jquery.validate';

if (!Array.prototype.flatMap) {
    Array.prototype.flatMap = function flatMap(f, ctx) {
        return this.reduce((r, x, i, a) => r.concat(f.call(ctx, x, i, a)), []);
    };
}

if (!Array.prototype.move) {
    Array.prototype.move = function(from, to) {
        this.splice(to, 0, this.splice(from, 1)[0]);
    };
}

if (!String.prototype.format) {
    String.prototype.format = function() {
        const args = arguments;

        return this.replace(/{(\d+)}/g, function(match, number) {
            return typeof args[number] !== 'undefined' ? args[number] : match;
        });
    };
}

if (!Array.prototype.reduce) {
    Array.prototype.reduce = function(callbackFn, initialValue) {
        var accumulator = initialValue;

        for (var i = 0; i < this.length; i++) {
            if (accumulator !== undefined)
                accumulator = callbackFn.call(undefined, accumulator, this[i], i, this);
            else
                accumulator = this[i];
        }

        return accumulator;
    }
}

if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function(search, replacement) {
        const target = this;
        return target.replace(new RegExp(search, 'g'), replacement);
    };
}

onLoad();

document.addEventListener('DOMContentUpdated', e => onLoad(e.target));

export function onLoad(context = document) {
    parseDynamicContent(context);
}